var server_host_domain = "https://clutch-customers-followup.vercel.app"
var form_webhook = "/form"
var options_webhook = "/salespersons"
var server_request_url = server_host_domain + form_webhook
  
var title = document.querySelector('#title_subtext');
var form = document.querySelectorAll('input[value=create_customer]');
var form = form[0]?.form;
var passwordInputs = form?.querySelectorAll('input[type=password]');
for (let i = 0; i < passwordInputs.length; i++) {
    passwordInputs[i].parentElement.remove();
}
var submitButton = form.querySelector('input[type=submit]') || form.querySelector('button');
var parentDiv = document.createElement('div');
var returnMessageDiv = document.createElement('div');
parentDiv.classList.add('ev_parent_return_message');
returnMessageDiv.classList.add('ev_return_message');
returnMessageDiv.style.cssText = `background: #000; z-index: 999; text-align: center; padding: 15px; border-radius: 5px; position: fixed; transition: bottom 0.4s ease-out; color: white; font-weight: 600; bottom: -100px;`;
parentDiv.appendChild(returnMessageDiv);
document.body.appendChild(parentDiv);
submitButton.type = "button";
submitButton.addEventListener("click", async function (e) {
    submitButton.disabled = true;
  
    var loadingDiv = document.createElement('div');
    loadingDiv.innerHTML = `<span style="border: 6px solid #ffffff; border-radius: 50%; border-top: 6px solid #000000; width: 50px; height: 50px; -webkit-animation: spin 2s linear infinite; animation: spin 1s linear infinite;"></span>`;
    loadingDiv.style.cssText = `position: fixed; background: rgba(0,0,0,0.5); width: 100%; top: 0; bottom: 0; color: white; z-index: 999; text-align: center; display: flex; flex-wrap: wrap; align-items: center; justify-content: center;`;
    document.body.appendChild(loadingDiv);
  
    var formData = new FormData(form);
    var jsonFormData = {};
    formData.forEach(function(value, key) {
        jsonFormData[key] = value;
    });
    try {
        const response = await fetch(server_request_url, {
            method: "POST",
            headers: {
      'Content-Type': 'application/json'},
            body: JSON.stringify(jsonFormData)
        });
        
        const resData = await response.json();
        if (resData.status == 200) {
            form.remove()
            insertMessage(resData.htmlMessage, hide=false);
        } else {
            insertMessage(resData.htmlMessage);
            // var errorKey = Object.keys(resData.data)[0];
            // returnCall(`${errorKey} ${resData.data[errorKey][0]}`, '#da2f0c', loadingDiv);
        }
    } catch (error) {
        insertMessage('<div class="error_box" style="margin-bottom: 10px; border: 1px solid red; padding: 10px;"><p style="color: red;">An error has occurred, please re-try again in a few moments, or <a href="https://clutchhairculture.com/pages/contact-us" target="_blank">contact us</a> to create the account for you.</p></div>', hide=false);
        console.error('Error sending data to webhook:', error);
    } finally {
      loadingDiv.remove();
      submitButton.disabled = false;
    }

});

function removeMessage(msg_id){
  message_ele = document.getElementById(msg_id);
  if (message_ele) {
    message_ele.remove();
  }
}
var last_msg
function insertMessage(value, hide=true) {
  removeMessage(last_msg);
  // form.insertAdjacentHTML("beforebegin", '<div id="message">'+value+'</div>');
  msg_id = "message_"+makeid(5)
  last_msg = msg_id
  title.insertAdjacentHTML("afterend", `<div id=${msg_id}>`+value+'</div>');
  window.scrollTo(0, 0);
  if (hide){
    setTimeout(removeMessage, 8000+(value.length*10), msg_id);  
  }
}

function returnCall(value, color, elem) {
    returnMessageDiv.style.bottom = "70px";
    returnMessageDiv.style.background = color;
    returnMessageDiv.innerHTML = value;
    elem.remove();
    setTimeout(myGreeting, 3000);
}
  
function makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}
  
function myGreeting() {
    returnMessageDiv.style.bottom = "-100px";
}

document.addEventListener("DOMContentLoaded", function() {
    fetchOptions();
  });

function fetchOptions() {
  fetch(server_host_domain+options_webhook)
    .then(response => response.json())
    .then(data => {
      const selectElement = document.getElementById('refferedBy');
      data.splice(0, 0, "No");
      // data.splice(data.length, 0, "Other salesperson");
      data.forEach(option => {
        const optionElement = document.createElement('option');
        optionElement.value = option;
        optionElement.textContent = option;
        selectElement.appendChild(optionElement);
      });
    })
    .catch(error => console.error('Error fetching options:', error));
}